<template></template>
<script>
    import StorageUtils from "../../utils/StorageUtils";
    import {mapActions, mapGetters, createNamespacedHelpers} from 'vuex'

    const marketPlaceHelper = createNamespacedHelpers('market_places');

    const user = StorageUtils.getUser();
    const crudChannelId = user && user.id ? `cruds_channel_${user.id}` : '';
    const marketPlacesChannelId = user && user.id ? `market_places_channel_${user.id}` : '';

    export default {
        name: "CableMonitor",
        methods: {
            ...mapActions(['changeCrudNotifications']),
            ...marketPlaceHelper.mapMutations({
                saveMarketPlace: 'addUpdateEntry',
                destroyMarketPlace: 'removeEntry',
            }),
            notifyMenu(data) {
                if (data && data.name) {
                    let notification = {[data.name]: {color: 'red', content: 0, object: data.object}};

                    if (/market_places/.test(data.name)) {
                        notification = {[data.name]: {color: 'black', content: '!'}};
                    } else if (data.type !== 'update') {
                        const storeContent = this.crudNotifications[data.name];
                        if (storeContent && storeContent.content) notification[data.name].content = storeContent.content;
                        notification[data.name].content += 1;
                    }
                    this.changeCrudNotifications({...this.crudNotifications, ...notification})
                }
            }
        },
        computed: {
            ...mapGetters(['crudNotifications'])
        },
        channels: {
            [crudChannelId]: {
                received(data) {
                    this.notifyMenu(data)
                }
            },
            [marketPlacesChannelId]: {
                received({data: entity, name, type}) {
                    if (/(create|update)/.test(type)) this.saveMarketPlace(entity);
                    else if (/destroy/.test(type)) this.destroyMarketPlace(entity.id);
                    if (name) this.notifyMenu({name})
                }
            }
        },
        mounted() {
            if (crudChannelId) this.$cable.subscribe({channel: 'CrudsChannel'}, crudChannelId);
            if (marketPlacesChannelId) this.$cable.subscribe({channel: 'MarketPlacesChannel'}, marketPlacesChannelId);
        }
    }
</script>
